import logoCreek from "../common/assets/faviconCreek.png";
import logoNuevamente from "../common/assets/faviconNuevamente.png";
import logoHangover from "../common/assets/faviconHangover.png";
import logoLeparc from "../common/assets/faviconLeparc.png";
import logoKeops from "../common/assets/faviconKeops.png";
import logoQuickpass from "../common/assets/faviconQuickpass.png";
import logoRosario from "../common/assets/faviconRosario.png";
import logoWabi from "../common/assets/faviconWabi.png";
import logoRoof from "../common/assets/faviconRoof.png";
//import logoLeparc from "../../common/assets/logoLeparc.png";


let favicon = null;
const tenantId = process.env.REACT_APP_PRODUCT_ID;


if (tenantId == "creek") {
    favicon = logoCreek;
}else if (tenantId == "nuevamente") {
    favicon = logoNuevamente;
}else if (tenantId == "leparc") {
    favicon = logoLeparc;
}else if (tenantId == "hangover") {
    favicon = logoHangover;
}else if (tenantId == "keops") {
    favicon = logoKeops;
}else if (tenantId == "quickpass") {
    favicon = logoQuickpass;
}else if (tenantId == "rosario") {
    favicon = logoRosario;
}else if (tenantId == "wabi") {
    favicon = logoWabi;
}else if (tenantId == "roof") {
    favicon = logoRoof;
}


export default favicon;


// WEBPACK FOOTER //
// ./src/components/FaviconSelector.js